import React from 'react';

// axios
import axios from 'axios';
import axiosUrl from '../../axios/url';




// 프로젝트 생성 다이얼로그
export default function InviteDialog(param) {

    const [username, setUsername] = React.useState(''); // 이메일 형식

    function trim(stringToTrim) {
        return stringToTrim.replace(/^\s+|\s+$/g,"");
    }

    // 이메일 validation
    function validateEmailAddress(email) {
        var expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        return expression.test(String(email).toLowerCase());
   }

    function handleUsername(e){
        setUsername(trim(e.target.value));
    }
    async function sendEmail(){
        if(username === '') { alert('이메일주소를 확인하세요.'); return; }
        if(!validateEmailAddress(username)) { alert('이메일주소의 형식을 확인하세요.'); return; }
        //if(!window.confirm('초대장을 보내시겠습니까?')) return;

        await axios.post(axiosUrl.invite ,{
            username: username,
        })
        .then(function (res){
            //alert('초대장을 보냈습니다.');
            window.location.reload();
        })
        .catch(function (e) {
            alert(e.response.data.error.message);
        });
    }

    function resetUsername(){
        setUsername('');
    }
  

    return(
        <div className="modal fade" id="InviteDialog" data-keyboard="false" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                <div className="modal-header contentColor">
                    <h5 className="modal-title" id="exampleModalLabel">새 멤버 초대하기</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={resetUsername}>
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                 <input type="text" className="form-control" placeholder="초대장 보낼 이메일을 입력하세요." value={username} onChange={handleUsername} />
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-primary" onClick={sendEmail}  >초대장 보내기</button>
                </div>
                </div>
            </div>
            </div>
    );
}